import { Divider, FormControlLabel, MenuItem, Stack, Switch, TextField, Typography } from '@mui/material';
import { WizardValues } from './wizardTypes';

interface Step4Props {
  values: WizardValues;
  setField: <K extends keyof WizardValues>(field: K, value: WizardValues[K]) => void;
}

export const Step4ParentDetails = ({ values, setField }: Step4Props) => (
  <Stack spacing={2}>
    <Typography variant="subtitle2">Father</Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Name" fullWidth value={values.fatherName} onChange={(e) => setField('fatherName', e.target.value)} />
      <TextField label="Occupation" fullWidth value={values.fatherOccupation} onChange={(e) => setField('fatherOccupation', e.target.value)} />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Organization" fullWidth value={values.fatherOrganization} onChange={(e) => setField('fatherOrganization', e.target.value)} />
      <TextField label="Office phone" fullWidth value={values.fatherOfficePhone} onChange={(e) => setField('fatherOfficePhone', e.target.value)} />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Mobile" fullWidth value={values.fatherPhone} onChange={(e) => setField('fatherPhone', e.target.value)} />
      <TextField label="Email" type="email" fullWidth value={values.fatherEmail} onChange={(e) => setField('fatherEmail', e.target.value)} />
    </Stack>

    <Divider />
    <Typography variant="subtitle2">Mother</Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Name" fullWidth value={values.motherName} onChange={(e) => setField('motherName', e.target.value)} />
      <TextField label="Occupation" fullWidth value={values.motherOccupation} onChange={(e) => setField('motherOccupation', e.target.value)} />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Organization" fullWidth value={values.motherOrganization} onChange={(e) => setField('motherOrganization', e.target.value)} />
      <TextField label="Office phone" fullWidth value={values.motherOfficePhone} onChange={(e) => setField('motherOfficePhone', e.target.value)} />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Mobile" fullWidth value={values.motherPhone} onChange={(e) => setField('motherPhone', e.target.value)} />
      <TextField label="Email" type="email" fullWidth value={values.motherEmail} onChange={(e) => setField('motherEmail', e.target.value)} />
    </Stack>

    <FormControlLabel
      control={
        <Switch
          checked={values.parentsMet === true}
          onChange={(e) => setField('parentsMet', e.target.checked)}
        />
      }
      label="Parents met"
    />

    <Divider />
    <Typography variant="subtitle2">Guardian (optional)</Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Name" fullWidth value={values.guardianName} onChange={(e) => setField('guardianName', e.target.value)} />
      <TextField
        select
        label="Relationship"
        fullWidth
        value={values.guardianRelationship}
        onChange={(e) => setField('guardianRelationship', e.target.value)}
      >
        <MenuItem value="">
          <em>Not specified</em>
        </MenuItem>
        <MenuItem value="Uncle">Uncle</MenuItem>
        <MenuItem value="Aunt">Aunt</MenuItem>
        <MenuItem value="Sibling">Sibling</MenuItem>
        <MenuItem value="Grandparent">Grandparent</MenuItem>
        <MenuItem value="Other">Other</MenuItem>
      </TextField>
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Phone" fullWidth value={values.guardianPhone} onChange={(e) => setField('guardianPhone', e.target.value)} />
      <TextField label="Email" type="email" fullWidth value={values.guardianEmail} onChange={(e) => setField('guardianEmail', e.target.value)} />
    </Stack>
  </Stack>
);
